/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Jul 20 2022
*  File : DevelopmentModeHelper.ts
*******************************************/

class DevelopmentModeHelper {
    private isDevelopment = false;

    public enableDevelopmentMode() {
        this.isDevelopment = true;
    }

    public isDevelopmentMode(): boolean {
        return this.isDevelopment;
    }
}

export const devModeHelper = new DevelopmentModeHelper();